import { initReactI18next } from 'react-i18next';

import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enCommon from '@/locales/en/common.json';
import enContact from '@/locales/en/contact.json';
import enInformation from '@/locales/en/information.json';
import enIntroduce from '@/locales/en/introduce.json';
import enIntroduceHistory from '@/locales/en/introduce-history.json';
import enIntroduceRules from '@/locales/en/introduce-rules.json';
import enMypage from '@/locales/en/mypage.json';
import enPublication from '@/locales/en/publication.json';
import enSociety from '@/locales/en/society.json';
import koCommon from '@/locales/ko/common.json';
import koContact from '@/locales/ko/contact.json';
import koInformation from '@/locales/ko/information.json';
import koIntroduce from '@/locales/ko/introduce.json';
import koIntroduceHistory from '@/locales/ko/introduce-history.json';
import koIntroduceRules from '@/locales/ko/introduce-rules.json';
import koMypage from '@/locales/ko/mypage.json';
import koPublication from '@/locales/ko/publication.json';
import koSociety from '@/locales/ko/society.json';
import zhCommon from '@/locales/zh/common.json';
import zhContact from '@/locales/zh/contact.json';
import zhInformation from '@/locales/zh/information.json';
import zhIntroduce from '@/locales/zh/introduce.json';
import zhIntroduceHistory from '@/locales/zh/introduce-history.json';
import zhIntroduceRules from '@/locales/zh/introduce-rules.json';
import zhMypage from '@/locales/zh/mypage.json';
import zhPublication from '@/locales/zh/publication.json';
import zhSociety from '@/locales/zh/society.json';

const resources = {
	ko: {
		common: {
			...koCommon,
			...koContact,
			...koInformation,
			...koIntroduce,
			...koIntroduceHistory,
			...koIntroduceRules,
			...koMypage,
			...koPublication,
			...koSociety,
		},
	},
	en: {
		common: {
			...enCommon,
			...enContact,
			...enInformation,
			...enIntroduce,
			...enIntroduceHistory,
			...enIntroduceRules,
			...enMypage,
			...enPublication,
			...enSociety,
		},
	},
	zh: {
		common: {
			...zhCommon,
			...zhContact,
			...zhInformation,
			...zhIntroduce,
			...zhIntroduceHistory,
			...zhIntroduceRules,
			...zhMypage,
			...zhPublication,
			...zhSociety,
		},
	},
} as const;

void i18n
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'ko',
		supportedLngs: ['ko', 'en', 'zh'],
		nonExplicitSupportedLngs: true,
		load: 'languageOnly',
		defaultNS: 'common',
		ns: ['common'],
		keySeparator: false,
		nsSeparator: false,
		returnEmptyString: false,
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ['localStorage', 'navigator'],
			caches: ['localStorage'],
		},
	});

export default i18n;
